import ApiIcon from 'icons/menu/api.inline.svg';
import AppsIcon from 'icons/menu/apps.inline.svg';
import BecomeApartnerIcon from 'icons/menu/become-a-partner.inline.svg';
import BlogIcon from 'icons/menu/blog.inline.svg';
import ChartsIcon from 'icons/menu/charts.inline.svg';
import CodeIcon from 'icons/menu/code.inline.svg';
import CommunityIcon from 'icons/menu/community.inline.svg';
import CompareIcon from 'icons/menu/compare.inline.svg';
import CustomerCenterIcon from 'icons/menu/customer-center.inline.svg';
import CustomersIcon from 'icons/menu/customers.inline.svg';
import DataTeamsIcon from 'icons/menu/data-teams.inline.svg';
import DemoIcon from 'icons/menu/demo.inline.svg';
import DocsIcon from 'icons/menu/docs.inline.svg';
import EngineeringIcon from 'icons/menu/engineering.inline.svg';
import EnterpriseIcon from 'icons/menu/enterprise.inline.svg';
import EventsIcon from 'icons/menu/events.inline.svg';
import ExpandIcon from 'icons/menu/expand.inline.svg';
import ExperimentsIcon from 'icons/menu/experiments.inline.svg';
import GlossaryIcon from 'icons/menu/glossary.inline.svg';
import IndiesIcon from 'icons/menu/indies.inline.svg';
import InfrastructureIcon from 'icons/menu/infrastructure.inline.svg';
import IntegrationsIcon from 'icons/menu/integrations.inline.svg';
import LightbulbIcon from 'icons/menu/lightbulb.inline.svg';
import AdjustIcon from 'icons/menu/logos/adjust.inline.svg';
import AirbridgeIcon from 'icons/menu/logos/airbridge.inline.svg';
import AirshipIcon from 'icons/menu/logos/airship.inline.svg';
import AmplitudeIcon from 'icons/menu/logos/amplitude.inline.svg';
import AndroidIcon from 'icons/menu/logos/android.inline.svg';
import AppleAdServicesIcon from 'icons/menu/logos/apple-ads.inline.svg';
import AppsFlyerIcon from 'icons/menu/logos/apps-flyer.inline.svg';
import BranchIcon from 'icons/menu/logos/branch.inline.svg';
import BrazeIcon from 'icons/menu/logos/braze.inline.svg';
import CapacitorIcon from 'icons/menu/logos/capacitor.inline.svg';
import ClevertapIcon from 'icons/menu/logos/clevertap.inline.svg';
import CordovaIcon from 'icons/menu/logos/cordova.inline.svg';
import CustomerIoIcon from 'icons/menu/logos/customer-io.inline.svg';
import DiscordIcon from 'icons/menu/logos/discord.inline.svg';
import FacebookAdsIcon from 'icons/menu/logos/facebook-ads.inline.svg';
import FirebaseIcon from 'icons/menu/logos/firebase.inline.svg';
import FlutterIcon from 'icons/menu/logos/flutter.inline.svg';
import GithubIcon from 'icons/menu/logos/github.inline.svg';
import IntercomIcon from 'icons/menu/logos/intercom.inline.svg';
import IonicIcon from 'icons/menu/logos/ionic.inline.svg';
import IosIcon from 'icons/menu/logos/ios.inline.svg';
import IterableIcon from 'icons/menu/logos/iterable.inline.svg';
import KotlinIcon from 'icons/menu/logos/kotlin.inline.svg';
import MacOsIcon from 'icons/menu/logos/mac-os.inline.svg';
import MetaIcon from 'icons/menu/logos/meta.inline.svg';
import MixpanelIcon from 'icons/menu/logos/mixpanel.inline.svg';
import mParticleIcon from 'icons/menu/logos/mparticle.inline.svg';
import OneSignalIcon from 'icons/menu/logos/one-signal.inline.svg';
import PaddleIcon from 'icons/menu/logos/paddle.inline.svg';
import PosthogIcon from 'icons/menu/logos/posthog.inline.svg';
import ReactIcon from 'icons/menu/logos/react.inline.svg';
import RokuIcon from 'icons/menu/logos/roku.inline.svg';
import SegmentIcon from 'icons/menu/logos/segment.inline.svg';
import SingularIcon from 'icons/menu/logos/singular.inline.svg';
import SlackIcon from 'icons/menu/logos/slack.inline.svg';
import SplitMetricsIcon from 'icons/menu/logos/split-metrics.inline.svg';
import StatsigIcon from 'icons/menu/logos/statsig.inline.svg';
import StripeIcon from 'icons/menu/logos/stripe.inline.svg';
import SuperwallIcon from 'icons/menu/logos/superwall.inline.svg';
import TenjinIcon from 'icons/menu/logos/tenjin.inline.svg';
import UnityIcon from 'icons/menu/logos/unity.inline.svg';
import WebhooksIcon from 'icons/menu/logos/webhooks.inline.svg';
import MarketersIcon from 'icons/menu/marketers.inline.svg';
import MigrationIcon from 'icons/menu/migration.inline.svg';
import NativeIntegrationsIcon from 'icons/menu/native-integrations.inline.svg';
import PaywallsSmallIcon from 'icons/menu/paywalls-small.inline.svg';
import PaywallsIcon from 'icons/menu/paywalls.inline.svg';
import PodcastIcon from 'icons/menu/podcast.inline.svg';
import QuickstartIcon from 'icons/menu/quickstart.inline.svg';
import RecipeIcon from 'icons/menu/recipe.inline.svg';
import ReliabilityIcon from 'icons/menu/reliability.inline.svg';
import ReportIcon from 'icons/menu/report.inline.svg';
import SdkIcon from 'icons/menu/sdk.inline.svg';
import StartupsIcon from 'icons/menu/startups.inline.svg';
import StatusIcon from 'icons/menu/status.inline.svg';
import StreamingIcon from 'icons/menu/streaming.inline.svg';
import TargetingIcon from 'icons/menu/targeting.inline.svg';
import TutorialsIcon from 'icons/menu/tutorials.inline.svg';
import UsersIcon from 'icons/menu/users.inline.svg';
import WebToMobileIcon from 'icons/menu/web-to-mobile.inline.svg';
import WebinarsIcon from 'icons/menu/webinars.inline.svg';
import WhyIcon from 'icons/menu/why.inline.svg';

const MENU_ICONS = {
  adjust: AdjustIcon,
  airbridge: AirbridgeIcon,
  airship: AirshipIcon,
  amplitude: AmplitudeIcon,
  android: AndroidIcon,
  api: ApiIcon,
  appleAds: AppleAdServicesIcon,
  apps: AppsIcon,
  appsflyer: AppsFlyerIcon,
  becomeAPartner: BecomeApartnerIcon,
  blog: BlogIcon,
  branch: BranchIcon,
  braze: BrazeIcon,
  capacitor: CapacitorIcon,
  charts: ChartsIcon,
  clevertap: ClevertapIcon,
  code: CodeIcon,
  community: CommunityIcon,
  compare: CompareIcon,
  customerCenter: CustomerCenterIcon,
  customerIo: CustomerIoIcon,
  cordova: CordovaIcon,
  customers: CustomersIcon,
  dataTeams: DataTeamsIcon,
  demo: DemoIcon,
  discord: DiscordIcon,
  docs: DocsIcon,
  engineering: EngineeringIcon,
  enterprise: EnterpriseIcon,
  events: EventsIcon,
  expand: ExpandIcon,
  experiments: ExperimentsIcon,
  facebookAds: FacebookAdsIcon,
  firebase: FirebaseIcon,
  flutter: FlutterIcon,
  github: GithubIcon,
  glossary: GlossaryIcon,
  indies: IndiesIcon,
  infrastructure: InfrastructureIcon,
  integrations: IntegrationsIcon,
  intercom: IntercomIcon,
  ionic: IonicIcon,
  ios: IosIcon,
  iterable: IterableIcon,
  kotlin: KotlinIcon,
  lightbulb: LightbulbIcon,
  macOs: MacOsIcon,
  marketers: MarketersIcon,
  meta: MetaIcon,
  migration: MigrationIcon,
  mixpanel: MixpanelIcon,
  mparticle: mParticleIcon,
  nativeIntegrations: NativeIntegrationsIcon,
  onesignal: OneSignalIcon,
  posthog: PosthogIcon,
  paddle: PaddleIcon,
  paywalls: PaywallsIcon,
  paywallsSmall: PaywallsSmallIcon,
  podcast: PodcastIcon,
  quickstart: QuickstartIcon,
  react: ReactIcon,
  recipe: RecipeIcon,
  reliability: ReliabilityIcon,
  report: ReportIcon,
  roku: RokuIcon,
  sdk: SdkIcon,
  segment: SegmentIcon,
  singular: SingularIcon,
  slack: SlackIcon,
  splitMetrics: SplitMetricsIcon,
  startups: StartupsIcon,
  statsig: StatsigIcon,
  status: StatusIcon,
  stripe: StripeIcon,
  stripeColor: StripeIcon,
  streaming: StreamingIcon,
  superwall: SuperwallIcon,
  targeting: TargetingIcon,
  tenjin: TenjinIcon,
  tutorials: TutorialsIcon,
  unity: UnityIcon,
  users: UsersIcon,
  webinars: WebinarsIcon,
  webhooks: WebhooksIcon,
  webToMobile: WebToMobileIcon,
  why: WhyIcon,
};

export default MENU_ICONS;
